import { render } from "./sekretariat.vue?vue&type=template&id=73c93d04"
import script from "./sekretariat.vue?vue&type=script&lang=js"
export * from "./sekretariat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__